import { Loader } from "@googlemaps/js-api-loader";
import removeSpace from "src/helpers/Handlebars/removeSpace.js";

document.addEventListener("DOMContentLoaded", function () {
    const mapCanvas = document.getElementById("map");
    if (!mapCanvas) {
        return
    }

    // register loader
    const loader = new Loader({
        apiKey: "AIzaSyCLRQLQVcrA1PEcpmlmzjW8_2-_tLyTHAg",
        version: "weekly",
    });

    // load
    loader
        .importLibrary("maps", "marker")
        .then(() => {
            initMap();
        })
        .catch((error) => {
            console.error("Error loading Google Maps:", error);
        });

    /**
     * Initialise the map
     *
     *
     */
    function initMap() {
        // display the map
        const bounds = new google.maps.LatLngBounds();
        const mapOptions = {
            mapTypeId: "roadmap",
        };
        const map = new google.maps.Map(mapCanvas, mapOptions);

        // fetch markers data from html
        const markersCards = document.querySelectorAll(".locations__card")
        const markers = Array.from(markersCards, el => ({
            name: el.dataset.name,
            lat: Number(el.dataset.lat),
            lng: Number(el.dataset.lng),
            address: el.dataset.address,
        }));

        let currentInfoWindow = null;

        // define the custom marker
        const customMarkerSVG = `
            <svg width="50" height="50" viewBox="0 0 800 800" xmlns="http://www.w3.org/2000/svg">
                <defs>
                <filter id="drop-shadow" x="-50%" y="-50%" width="200%" height="200%">
                    <feGaussianBlur in="SourceAlpha" stdDeviation="15" />
                    <feOffset dx="10" dy="10" result="offsetblur" />
                    <feMerge>
                    <feMergeNode />
                    <feMergeNode in="SourceGraphic" />
                    </feMerge>
                </filter>
                </defs>
                <g id="Marker" filter="url(#drop-shadow)">
                <path id="Shape" d="M400,0C571.822,0 711.111,125.356 711.111,280C711.111,532.511 400,800 400,800C400,800 88.889,534.756 88.889,280C88.889,125.356 228.178,0 400,0Z" style="fill:rgb(46,132,75);" />
                <circle id="Oval" cx="400" cy="311.111" r="155.556" style="fill:rgb(0, 91, 35);" />
                </g>
            </svg>
        `;
        const customIcon = {
            url: 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(customMarkerSVG),
            scaledSize: new google.maps.Size(50, 50),
            anchor: new google.maps.Point(25, 50)
        };

        // add markers to map
        markers.forEach(({name, lat, lng, address}) => {
            const position = new google.maps.LatLng(lat, lng);
            bounds.extend(position);

            const marker = new google.maps.Marker({
                position: position,
                map: map,
                title: name,
                icon: customIcon
            });

            const infoWindow = new google.maps.InfoWindow({
                content: `
                    <div class="locations__info-content">
                        <p class="locations__info-content__name"><strong>${name}</strong></p>
                        <div class="locations__info-content__address">
                            ${address}
                        </div>
                        <div>
                            <a href="#${removeSpace(name)}">Details</a>
                        </div>
                    </div>
                    `
            });

            marker.addListener("click", () => {
                if (currentInfoWindow) {
                    currentInfoWindow.close();
                }
                infoWindow.open(map, marker);
                currentInfoWindow = infoWindow;
                map.setCenter(position);
                // map.setZoom(12);
            });
        });

        // adjust map to fit bounds of markers
        map.fitBounds(bounds);
    }
});
